import React from "react";
import { SignupPage } from "../..//Pages/Signup/Signup";

function Signup() {
  return <div>
    <SignupPage/>
  </div>;
}

export { Signup };
